<div class="container">
    <div class="text-center">
        <h1>Dax Trend</h1>
    </div>
    <div class="row" style="padding: 5px;">
        <div class="col-12">
            <mdb-tabs>

                <mdb-tab title="Giorni del mese BUY">

                    <div class="row">

                        <div class="col-12 text-center">
                            <h3>Giorni del mese</h3>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-3">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th colspan="6">Giorno del mese BUY</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th *ngFor="let c of colonne">{{(c>0) ? c : 'Trading Day'}}</th>
                                    </tr>
                                    <tr *ngFor="let rb of righeBuy; let id = index">
                                        <td>{{id+1}}</td>
                                        <td [ngClass]="colora2[id][rb[0]] ? 'cellaBuy' : 'red'"
                                            (click)="cambiaBuy(id,0,colora2[id][rb[0]])">
                                            .</td>
                                        <td [ngClass]="colora2[id][rb[1]] ? 'cellaBuy' : 'red'"
                                            (click)="cambiaBuy(id,1,colora2[id][rb[1]])">
                                            .</td>
                                        <td [ngClass]="colora2[id][rb[2]] ? 'cellaBuy' : 'red'"
                                            (click)="cambiaBuy(id,2,colora2[id][rb[2]])">
                                            .</td>
                                        <td [ngClass]="colora2[id][rb[3]] ? 'cellaBuy' : 'red'"
                                            (click)="cambiaBuy(id,3,colora2[id][rb[3]])">
                                            .</td>
                                        <td [ngClass]="colora2[id][rb[4]] ? 'cellaBuy' : 'red'"
                                            (click)="cambiaBuy(id,4,colora2[id][rb[4]])">.</td>

                                    </tr>
                                </tbody>
                            </table>


                        </div>
                    </div>
                </mdb-tab>
                <mdb-tab title="Giorni del mese SELL">

                    <div class="row">

                        <div class="col-12 text-center">
                            <h3>Giorni del mese</h3>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-3">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th colspan="5">Giorno del mese SELL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th *ngFor="let c of colonne">{{(c>0) ? c : 'Trading Day'}}</th>
                                    </tr><!---->
                                    <tr *ngFor="let r of righeSell; let id = index">
                                        <td>{{id+1}}</td>
                                        <td [ngClass]="colora[id][r[0]] ? 'cella' : 'red'" (click)="cambiaSell(id,0,colora[id][r[0]])">
                                            .
                                        </td>
                                        <td [ngClass]="colora[id][r[1]] ? 'cella' : 'red'" (click)="cambiaSell(id,1,colora[id][r[1]])">
                                            .
                                        </td>
                                        <td [ngClass]="colora[id][r[2]] ? 'cella' : 'red'" (click)="cambiaSell(id,2,colora[id][r[2]])">
                                            .
                                        </td>
                                        <td [ngClass]="colora[id][r[3]] ? 'cella' : 'red'" (click)="cambiaSell(id,3,colora[id][r[3]])">
                                            .
                                        </td>
                                        <td [ngClass]="colora[id][r[4]] ? 'cella' : 'red'" (click)="cambiaSell(id,4,colora[id][r[4]])">
                                            .
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </mdb-tab>
                <mdb-tab title="Mesi dell'anno">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h3>Mesi dell'anno</h3>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-4 text-center">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Mesi</th>
                                        <th>BUY</th>
                                        <th>SELL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let r of mesi">
                                        <td>{{r.mese}}</td>
                                        <td [ngClass]="r.buy==1 ? 'cella' : 'red'"
                                            (click)="cambiaMese(r.id,'buy', (r.buy==1 ? 0 : 1))">
                                        </td>
                                        <td [ngClass]="r.sell==1 ? 'cella' : 'red'"
                                            (click)="cambiaMese(r.id,'sell', (r.sell==1 ? 0 : 1))">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mdb-tab>
                <mdb-tab title="Livelli">

                    <div class="row d-flex justify-content-center">
                        <div class="col-3">
                            <h3>Distanza percentuale</h3>
                        </div>
                    </div>
                    <form [formGroup]="percBuySell">
                    <div class="row d-flex justify-content-center">
                        <div class="col-3 m-3">
                            <mdb-form-control>
                                <input mdbInput formControlName="percBuy" class="form-control" id="percBuy" type="text" value="45" style="text-align:right">
                                <label mdbLabel class="form-label" for="percBuy">Percentuale Buy</label>
                            </mdb-form-control>
                        </div>
                    </div>
                    
                    <div class="row d-flex justify-content-center">
                        <div class="col-3 m-5">
                            <mdb-form-control>
                                <input mdbInput formControlName="percSell" class="form-control" id="percSell" type="text" value="15" style="text-align:right">
                                <label mdbLabel class="form-label" for="percSell">Percentuale Sell</label>
                            </mdb-form-control>
                            
                        </div>

                    </div>
                    
                    <div class="row d-flex justify-content-center">
                        <div class="col-3">
                            <input type="button" mdbButton class="form-control btn btn-primary" value="SALVA DATI" (click)="salvaPerc()">
                        </div>
                    </div>
                </form>
                </mdb-tab>
            </mdb-tabs>
        </div>

    </div>
</div>